import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CambiarClaveDialogComponent } from './cambiar-clave-dialog/cambiar-clave-dialog.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecuperarClaveDialogComponent } from './recuperar-clave-dialog/recuperar-clave-dialog.component';



@NgModule({
  declarations: [CambiarClaveDialogComponent, RecuperarClaveDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
  ]
})
export class CambiarClaveModule { }
